

























import { Component, Vue, Prop } from 'vue-property-decorator'
import ShowImg from '../ui/ShowImg.vue'
/**
 * 最佳拍档
 */
@Component({
  components: {
    ShowImg
  }
})
export default class Partner extends Vue {
  @Prop()
  public dataList: any

  protected goDetails(item: any) {
    this.$router.push({ name: 'goods-details', query: { id: item.id } })
  }
}
